/** The token persisted by the latest login, not the value captured when axios started. */
export function applyRequestAuthorization(
    headers: object,
    localToken: string | null | undefined,
    cookieToken: string | null | undefined
): void {
    const bag = headers as {
        Authorization?: string;
        authorization?: string;
        set?: (name: string, value: string) => void;
        delete?: (name: string) => void;
    };
    const token = localToken || cookieToken || '';
    if (token) {
        if (typeof bag.set === 'function') {
            bag.set('Authorization', `Bearer ${token}`);
        } else {
            bag.Authorization = `Bearer ${token}`;
        }
        return;
    }
    if (typeof bag.delete === 'function') {
        bag.delete('Authorization');
    }
    delete bag.Authorization;
    delete bag.authorization;
}
